module.exports = __webpack_public_path__ + "img/book.0a9d320c.svg";